/// <reference lib="es2021.intl" />
import { getLanguage } from './languageManager';
import en from './messages/en';
import es from './messages/es';
import fr from './messages/fr';
import { sharedCopy } from './sharedCopy';
import { residualCopy } from './residualCopy';
import { developCopy } from './developCopy';

export const sourceMessages: Record<string, Record<string, string>> = { 'pt-BR': sharedCopy['pt-BR'], en: { ...en, ...sharedCopy.en, ...residualCopy.en, ...developCopy.en }, es: { ...es, ...sharedCopy.es, ...residualCopy.es, ...developCopy.es }, fr: { ...fr, ...sharedCopy.fr, ...residualCopy.fr, ...developCopy.fr } };
export type TranslationValues = Record<string, string | number>;

/** Translate interface copy only. User content belongs in interpolation values. */
export function tx(source: string, values?: TranslationValues): string {
  const translated = sourceMessages[getLanguage()]?.[source] ?? source;
  return values ? translated.replace(/\{(\w+)\}/g, (placeholder, key) =>
    Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : placeholder,
  ) : translated;
}

export const formatNumber = (value: number, options?: Intl.NumberFormatOptions) =>
  new Intl.NumberFormat(getLanguage(), options).format(value);
export const formatDate = (value: Date | number, options?: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat(getLanguage(), options).format(value);
export const getPluralCategory = (value: number) => new Intl.PluralRules(getLanguage()).select(value);

/** Translate country/language labels with native locale data; never alter stored codes. */
export function getRegionName(code: string, fallback = code): string {
  try {
    return new Intl.DisplayNames([getLanguage()], { type: 'region' }).of(code === 'UK' ? 'GB' : code) ?? fallback;
  } catch { return fallback; }
}
export function getLanguageName(code: string, fallback = code): string {
  try {
    return new Intl.DisplayNames([getLanguage()], { type: 'language' }).of(code) ?? fallback;
  } catch { return fallback; }
}
